import * as actionTypes from './actions';

const initialState = {
  value: 0
};

export default function pendingApprovals(state = initialState, action) {
  switch (action.type) {
    case actionTypes.PENDING_APPROVALS_SET: {
      const next = Number(action.payload) || 0;
      return { ...state, value: next };
    }
    case actionTypes.PENDING_APPROVALS_INC:
      return { ...state, value: state.value + 1 };
    case actionTypes.PENDING_APPROVALS_DEC:
      return { ...state, value: Math.max(0, state.value - 1) };
    default:
      return state;
  }
}
